import angular from 'angular';
import proxyingCustomerInfoPanelComponent from './proxyingCustomerInfoPanel.component';

let proxyingCustomerInfoPanelModule = angular.module('proxyingCustomerInfoPanel', []).component('proxyingCustomerInfoPanel', proxyingCustomerInfoPanelComponent);

export default proxyingCustomerInfoPanelModule;



// WEBPACK FOOTER //
// ./app/components/proxyingCustomerInfoPanel/proxyingCustomerInfoPanel.js